import OffersHeader from './../../components/component/header/offers_header.jsx';

import Offer from './../../components/component/offer_components/offer.jsx';


import FooterOffers from './../../components/component/footer/footer_offers.jsx';
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';



function Offers() {
    return (
        <main>
            <OffersHeader />
            <Offer />


            <FooterOffers />
            <LaptopFooter />


        </main>
    );
}

export default Offers;

